export const ENTITY_USERS = '/entities/:entityId/users';
export const ENTITY_USERS_LEGACY = '/entities/:entityId/user';
export const USER_LIST = '/users';
export const USER_LIST_LEGACY = '/user';
export const LOGOUT = '/logout';
export const ALLOCATION_ENGINE = '/settings';
export const ALLOCATION_ENGINE_INTERNAL_USERS = '/entity/:entityId/Internaluser';
export const AE_BUSINESS_UNITS = '/settings/business-units';
export const AE_BUSINESS_UNIT_DETAIL = '/settings/business-units/:businessUnitId/:tabKey?';
export const AE_BRANCH = '/settings/branch/:tabKey?';

export const AE_BRANCH_DETAIL = '/settings/branch/:branchId/:tabKey?';
export const AE_BRANCH_MEMBER_DETAIL = '/settings/branch/:branchId/member/:memberId';
export const AE_SUB_BRANCH = '/settings/sub-branch';
export const AE_SUB_BRANCH_DETAIL = '/settings/sub-branch/:branchId/:tabKey?';
export const AE_SUB_BRANCH_MAIN = '/settings/sub-branch/:subBranchId/detail/:tabKey?';
export const GOVERNANCE_MODAL = '/settings/business-units/:businessUnitId/:tabKey/governance';
export const MASTERS = '/settings/masters';
export const MASTERS_CREATE_INFO = '/settings/masters-create-info';
export const MASTERS_CREATION = '/settings/masters-creation';
export const MASTER_DETAIL = '/settings/masters/:masterId';
export const MASTER_VERSIONS = '/settings/masters/:masterId/versions';
export const MASTER_VERSION_DETAIL = '/settings/masters/:masterId/versions/:versionId';
export const FORBIDDEN = '/forbidden';
export const ACTIVATE = '/activate';
export const FORGOT_PASSWORD = '/forgot-password';
export const IAM = '/iam';
export const IAM_PRODUCT = '/iam/:productCode';
export const MANAGE_ROLES = '/iam/:productCode/manage-roles';
export const MANAGE_USERS = '/iam/:productCode/manage-users';
